var $animation_elements;
var $window;

jQuery(document).ready(function ($) {

    var $window = jQuery(window);
    $animation_elements = jQuery('section.category__carousel');

    if ($('body').hasClass('page-template-products-archive')) {
        initCarousels();
        initStickyNav();
    }

    if ($('body').hasClass('single-products')) {
        initProductCarousels();
        initProductTabs();

        window.onresize = updateScreenSize;
    }

    updateScreenSize();

    //$window.on('scroll resize', check_if_in_view);

    initWaypoints();
});

var featuresCarousel;
var popularOptionsCarousel;

function updateScreenSize() {

    if (window.innerWidth < 860 && !jQuery('html').hasClass('tab-carousel')) {
        jQuery('.tab-content').addClass('owl-carousel');
        
        featuresCarousel = jQuery('.tab-content[data-type=features]').owlCarousel({
            items: 4,
            margin: 0,
            nav: false,
            dots: true,
            nextArrow: '<span class="cs-left-arrow"><i class="fa fa-chevron-left"></i></span>',
            prevArrow: '<span class="cs-right-arrow"><i class="fa fa-chevron-right"></i></span>',
            responsive : {
                0: {
                    items: 1
                },
                400: {
                    items: 2
                },
                800: {
                    items: 4
                }
            }
        });

        popularOptionsCarousel = jQuery('.tab-content[data-type=popular-options]').owlCarousel({
            items: 4,
            margin: 0,
            nav: false,
            dots: true,
            nextArrow: '<span class="cs-left-arrow"><i class="fa fa-chevron-left"></i></span>',
            prevArrow: '<span class="cs-right-arrow"><i class="fa fa-chevron-right"></i></span>',
            responsive : {
                0: {
                    items: 1
                },
                800: {
                    items: 2
                }
            }
        });
    }

    else {
        if(jQuery(featuresCarousel).length > 0 && featuresCarousel.hasClass('owl-loaded')){
            jQuery(featuresCarousel).trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
            jQuery(featuresCarousel).find('.owl-stage-outer').children().unwrap();
        }
        if(jQuery(featuresCarousel).length > 0 && popularOptionsCarousel.hasClass('owl-loaded')){
            jQuery(popularOptionsCarousel).trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
            jQuery(popularOptionsCarousel).find('.owl-stage-outer').children().unwrap();
        }
        
        
    }

}



function initProductTabs() {

    var productTabs = jQuery('.product__tab');

    if (productTabs.length > 0) {

        productTabs.each(function () {

            jQuery(this).on({

                click: function (e) {
                    e.preventDefault();

                    if (!jQuery(this).hasClass('active')) {

                        jQuery('.product__tab').removeClass('active');
                        jQuery(this).addClass('active');

                        jQuery('.tab-content').removeClass('active');
                        jQuery('.tab-content[data-type=' + jQuery(this).attr('data-type') + ']').addClass('active');

                    }

                }

            });

        });

    }

}

/*
window.addEventListener('resize', function(event){
    if( ( window ).width() > 860 ){
        goDesktop();
    }
    else {
        goMobile();
    }
});


function goMobile(){
    jQuery('html').addClass('mobile');
    jQuery('html').removeClass('desktop');

    updateProductTabs('mobile');
}

function goDesktop(){
    jQuery('html').addClass('desktop');
    jQuery('html').removeClass('mobile');
}
*/


function initProductCarousels() {

    var productCarousel = jQuery('.owl-carousel.single-product-gallery');

    if (productCarousel.length > 0) {

        if (productCarousel.children().length > 1) {

            productCarousel.owlCarousel({
                items: 1,
                margin: 0,
                nav: false,
                dots: true
            });

        }
        else {
            productCarousel.fadeIn();
        }

    }

}


function initCarousels() {

    var carousels = jQuery('.category__products.owl-carousel');

    carousels.each(function () {

        currentCarousel = jQuery(this);

        if (currentCarousel.children().length > 0) {
            currentCarousel.owlCarousel({
                items: 4,
                margin: 10,
                autoplayTimeout: 200,
                navSpeed: 200,
                center: false,
                nav: true,
                dots: true,
                navText:[
                    '<span class="cs-left-arrow"><i class="fa fa-chevron-left"></i></span>',
                    '<span class="cs-right-arrow"><i class="fa fa-chevron-right"></i></span>'
                ],
                responsive: {
                    0: { items: 1, margin: 0 },
                    480: { items: 1, margin: 0 },
                    768: { items: 2 },
                    1000: { items: 4 }
                }
            });
        }
        else {
            currentCarousel.removeClass('owl-carousel');
        }

    });



}


var navbar, sticky;

function initStickyNav() {

    navbar = jQuery("nav.category__nav");

    if (navbar.length > 0) {
        sticky = navbar.offset().top;

        window.onscroll = function () {

            //console.log(sticky,window.pageYOffset);

            if (window.pageYOffset >= (sticky - 44)) {
                navbar.addClass("sticky")
            } else {
                navbar.removeClass("sticky");
            }

        };
    }

    navitems = jQuery("nav.category__nav ul li a");

    navitems.on({
        'click': function (e) {
            e.preventDefault();

            var self = this;

            var category = jQuery(this).attr('data-category');

            console.log(jQuery('h3[data-category=' + category + ']'));

            if (jQuery('h3[data-category=' + category + ']').length > 0) {
                jQuery('html, body').animate({
                    scrollTop: jQuery('h3[data-category=' + category + ']').offset().top - 250
                }, 1000);
            }


        }
    });


    var mobileSelector = jQuery('select.category__nav-mobile');

    mobileSelector.on({
        'change' : function (e) {
            e.preventDefault();

            var self = this;

            var category = jQuery(this).children("option:selected").val();

            console.log(jQuery('h3[data-category=' + category + ']'));

            if (jQuery('h3[data-category=' + category + ']').length > 0) {
                jQuery('html, body').animate({
                    scrollTop: jQuery('h3[data-category=' + category + ']').offset().top - 160
                }, 1000);
            }


        }
    });


}




function check_if_in_view() {

    var $window = jQuery(window);
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    jQuery.each($animation_elements, function () {

        var $element = jQuery(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        console.log($element, element_height, element_top_position, element_bottom_position);

        //check to see if this current container is within viewport
        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('in-view');
        } else {
            $element.removeClass('in-view');
        }
    });
}

var waypoints;

function initWaypoints() {

    var sections = jQuery('section.category__carousel');
    if( sections.length > 0 ){

        sections.each(function(){

            var currentSection = jQuery(this);

            var waypoint = new Waypoint({
                element: currentSection,
                handler: function () {
                    jQuery('section.category__carousel').removeClass('active');
                    jQuery(this.element).addClass('active');

                    var currentCategory = jQuery(this.element).attr('data-category');

                    updateCategory(currentCategory);
                },
                offset: 'bottom-in-view'
            });
        });
    }

}

function updateCategory(currentCategory) {
    jQuery('.category__nav ul li').removeClass('active');
    jQuery('.category__nav ul li a[data-category='+currentCategory+']').parent().addClass('active');
}